// src/constants/sidebarMenu.jsx
import { ROLES } from './roles';


const ALL_ROLES        = Object.values(ROLES);

const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN];

const MANAGEMENT_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.OFFICE_ADMIN];
const DEALER_ROLES     = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.SALES_OFFICER, ROLES.EXECUTIVE, ROLES.OFFICE_ADMIN];
const FARMER_ROLES     = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER, ROLES.FIELD_AGENT];
const ORDER_ROLES      = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER];
const TEAM_VIEW_ROLES  = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER];
const SO_ROLES         = [ROLES.SALES_OFFICER];
const EXEC_ROLES       = [ROLES.EXECUTIVE, ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.OFFICE_ADMIN];
const GODOWN_ROLES     = [ROLES.GODOWN];
const TEAM_TOUR_ROLES = [
  ROLES.ADMIN, ROLES.SUPER_ADMIN,
  ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER,
  ROLES.EXECUTIVE, ROLES.SALES_OFFICER,
  ROLES.FIELD_AGENT,
];

const DEALER_VISIT_VIEW_ROLES = [
  ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN,
  ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER,
  ROLES.EXECUTIVE, ROLES.SALES_OFFICER,
];
const PAYMENT_ROLES = [
  ROLES.SALES_OFFICER, ROLES.EXECUTIVE, ROLES.AREA_MANAGER,
  ROLES.ZONAL_MANAGER, ROLES.ADMIN, ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN,
  ROLES.ACCOUNTS
]
const COMPANIES = [
  { id: 1, name: 'Amicus Agri' },
  { id: 2, name: 'MICROBAX' },
  { id: 3, name: 'Viyoni Agro' },
];
export const SIDEBAR_MENU = [
  // ── Dashboard ─────────────────────────────────────────────────────────────
  { id: 'dashboard', title: 'Dashboard', icon: 'solar:home-smile-angle-outline', roles: ALL_ROLES, children: [
    { id: 'dashboard-overview',  title: 'Overview',   path: '/dashboard/overview',  roles: ALL_ROLES },
    { id: 'dashboard-reports',   title: 'Reports',    path: '/dashboard/reports',   roles: ADMIN_ROLES },
    { id: 'dashboard-analytics', title: 'Analytics',  path: '/dashboard/analytics', roles: ADMIN_ROLES },
  ]},

  // ── Set Target ────────────────────────────────────────────────────────────
  { id: 'set-target', title: 'Set Target', icon: 'mdi:target', roles: MANAGEMENT_ROLES, children: [
    { id: 'target-zonal', title: 'Target to Zonal', path: '/target/zonal', roles: MANAGEMENT_ROLES },
  ]},

  // ── Manage Farmer ─────────────────────────────────────────────────────────
  { id: 'manage-farmer', title: 'Manage Farmer', icon: 'mdi:account-cowboy-hat', roles: FARMER_ROLES, children: [
    { id: 'add-farmer',     title: 'Add Farmer',     path: '/farmer/add',            roles: FARMER_ROLES },
    { id: 'view-farmer',    title: 'View Farmer',    path: '/farmer/view',           roles: FARMER_ROLES },
    // { id: 'first-visit',    title: 'First Visit',    path: '/farmer/first-visit',    roles: FARMER_ROLES },
    { id: 'farmer-visit', title: 'Farmer Visit', path: '/farmer/farmer-visit', roles: FARMER_ROLES },
  ]},

  // ── Manage Dealer ─────────────────────────────────────────────────────────
  { id: 'manage-dealer', title: 'Manage Dealer', icon: 'mdi:store', roles: DEALER_ROLES, children: [
    { id: 'add-dealer',  title: 'Add Dealer',  path: '/dealer/add',  roles: DEALER_ROLES },
    { id: 'view-dealer', title: 'View Dealer', path: '/dealer/view', roles: DEALER_ROLES },
    { id: 'dealer-visits', title: 'Dealer Visits', path: '/dealer/visits', roles: DEALER_VISIT_VIEW_ROLES },
  ]},

{
  id: 'sub-dealer',
  title: 'Sub-Dealers',
  icon: 'iconoir:shop',
  allowedRoles: [
    'SUPER_ADMIN', 'OFFICE_ADMIN', 'ADMIN',
    'ZONAL_MANAGER', 'AREA_MANAGER', 'EXECUTIVE', 'SALES_OFFICER',
    'FIELD_AGENT',
  ],
  children: [
    {
      id: 'sub-dealer-view',
      title: 'View Sub-Dealers',
      path: '/sub-dealer/view',
      roles: [
        'SUPER_ADMIN', 'OFFICE_ADMIN', 'ADMIN',
        'ZONAL_MANAGER', 'AREA_MANAGER', 'EXECUTIVE', 'SALES_OFFICER',
        'FIELD_AGENT',
      ],
    },
    {
      id: 'sub-dealer-add',
      title: 'Add Sub-Dealer',
      path: '/sub-dealer/add',
      roles: [
        'SUPER_ADMIN', 'OFFICE_ADMIN', 'ADMIN',
        'ZONAL_MANAGER', 'AREA_MANAGER', 'EXECUTIVE', 'SALES_OFFICER',
      ],
    },
  ],
},
  // ── Employee Management ───────────────────────────────────────────────────
  { id: 'employee-management', title: 'Employee Management', icon: 'mdi:account-group', roles: ADMIN_ROLES, children: [
    { id: 'add-employee',  title: 'Add Employee',  path: '/employee/add',  roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN] },
    { id: 'view-employee', title: 'View Employee', path: '/employee/view', roles:  [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN] },
  ]},

  // ── Company Management ────────────────────────────────────────────────────
  { id: 'company-management', title: 'Company Management', icon: 'mdi:office-building', roles: ADMIN_ROLES, children: [
    { id: 'add-company',         title: 'Add Company',  path: '/company/add',    roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN] },
    { id: 'view-company',        title: 'View Company', path: '/company/view',   roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN] }
  ]},

  // ── Product Management ────────────────────────────────────────────────────
  { id: 'product-management', title: 'Product Management', icon: 'mdi:package-variant-closed', roles: MANAGEMENT_ROLES, children: [
    { id: 'add-product',  title: 'Add Product',  path: '/product/add',          roles: ADMIN_ROLES },
    { id: 'view-product', title: 'View Product', path: '/product/view',         roles: MANAGEMENT_ROLES },
    { id: 'add-category', title: 'Add Category', path: '/product/category/add', roles: ADMIN_ROLES },
  ]},

  // ── Manage Region Area ────────────────────────────────────────────────────
  { id: 'manage-region', title: 'Manage Region Area', icon: 'mdi:map-marker-radius', roles: MANAGEMENT_ROLES, children: [
    { id: 'add-region',       title: 'Add Region',        path: '/region/add',              roles: ADMIN_ROLES },
    { id: 'view-region',      title: 'View Region',       path: '/region/view',             roles: MANAGEMENT_ROLES },
    { id: 'add-headquarter',  title: 'Add Headquarter',   path: '/headquarter/add',         roles: ADMIN_ROLES },
    { id: 'view-headquarter', title: 'View HeadQuarter',  path: '/headquarter/view',        roles: MANAGEMENT_ROLES },
    { id: 'add-subhq',        title: 'Add SubHq',         path: '/subhq/add',               roles: ADMIN_ROLES },
    { id: 'view-subhq',       title: 'View SubHq',        path: '/subhq/view',              roles: MANAGEMENT_ROLES },
    { id: 'change-hq',        title: 'Change HQ/SubHQ',   path: '/headquarter/change',      roles: ADMIN_ROLES },
    { id: 'add-village',      title: 'Add Village',       path: '/village/add',             roles: ADMIN_ROLES },
    { id: 'view-village',      title:'Villages List',     path: '/villages/list',           roles: ADMIN_ROLES },
    { id: 'upload-statement', title: 'Upload Statement',  path: '/region/statement/upload', roles: ADMIN_ROLES },
    { id: 'delete-statement', title: 'Delete Statement',  path: '/region/statement/delete', roles: ADMIN_ROLES },
  ]},

  // ── Godown Management (Admin view) ────────────────────────────────────────
  { id: 'godown-management', title: 'Godown Management', icon: 'mdi:warehouse', roles: ADMIN_ROLES, children: [
    { id: 'add-godown',  title: 'Add Godown',  path: '/godown/add',  roles: ADMIN_ROLES },
    { id: 'view-godown', title: 'View Godown', path: '/godown/view', roles: ADMIN_ROLES },
     {
  id: 'view-godown-employee',
  title: 'View Godown Employee',
  path: '/team/godown-employees',
  roles: ADMIN_ROLES
},

  ]},

  // ── Godown (GODOWN role — operational view) ───────────────────────────────
{ id: 'godown-operations', title: 'Godown', icon: 'mdi:warehouse', roles: GODOWN_ROLES, children: [
  { id: 'my-godowns',        title: 'My Godowns',  path: '/godown/my-godowns',       roles: GODOWN_ROLES },
  { id: 'godown-dashboard',  title: 'Dashboard',   path: '/godown/dashboard',        roles: GODOWN_ROLES },
  { id: 'godown-orders',     title: 'Orders',      path: '/orders/godown-dashboard', roles: GODOWN_ROLES },
]},

 { id: 'tour', title: 'Tour', icon: 'mdi:map-marker-path',
  roles: TEAM_TOUR_ROLES,
  children: [
    { id: 'tour-start-km',    title: 'Start KM',    path: '/tour/start-km',    roles: TEAM_TOUR_ROLES },
    { id: 'tour-dealer-visit',title: 'Dealer Visit', path: '/tour/dealer-visit',roles: TEAM_TOUR_ROLES },
    { id: 'tour-end-km',      title: 'End My Tour',  path: '/tour/end-km',      roles:TEAM_TOUR_ROLES},
    { id: 'tour-monthly',     title: 'My Tours',     path: '/tour/monthly',     roles: TEAM_TOUR_ROLES },
    { id: 'tour-team',        title: 'Team Tours',   path: '/tour/team-tours',  roles: TEAM_TOUR_ROLES },
  ]
},
 {
  id: 'statement-management',
  title: 'Company Statements',
  icon: 'mdi:file-document',
  roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ZONAL_MANAGER],
  children: [
    {
      id: 'tour-statements',
      title: 'Tour Statements',
      path: '/statements/employees',
      icon: 'mdi:calendar-check',
      roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ZONAL_MANAGER],
      showCompany: true,
    },
  ],
},

// ── Tour Management ───────────────────────────────────────────────────────
  // { id: 'order-tour-management', title: 'Tour Management', icon: 'mdi:clipboard-text-clock', roles: ORDER_ROLES, children: [
  //   { id: 'godown-dashboard-mgmt', title: 'Godown Dashboard',    path: '/orders/godown-dashboard', roles: ADMIN_ROLES },
  //   { id: 'view-tour-statements',  title: 'View Tour Statements', path: '/orders/tour-statements', roles: ORDER_ROLES },
  //   { id: 'upload-document',       title: 'Upload Document',      path: '/orders/document/upload', roles: ORDER_ROLES },
  //   { id: 'delete-document',       title: 'Delete Document',      path: '/orders/document/delete', roles: ADMIN_ROLES },
  // ]},

  // ── Order Management ──────────────────────────────────────────────────────
  { id: 'order-management', title: 'Order Management', icon: 'mdi:clipboard-list', roles: [...SO_ROLES, ...EXEC_ROLES], children: [
    { id: 'create-order', title: 'Create Order', path: '/orders/create',    roles: DEALER_VISIT_VIEW_ROLES },
    { id: 'my-orders',    title: 'My Orders',    path: '/orders/my-orders', roles: DEALER_VISIT_VIEW_ROLES },
    { id: 'all-orders',   title: 'All Orders',   path: '/orders/all',       roles: EXEC_ROLES },
     { id: 'view-payments', title: 'Payments',      path: '/orders/payments',  roles: PAYMENT_ROLES },
  ]},

  // ── View Team ─────────────────────────────────────────────────────────────
  { id: 'view-team', title: 'View Team', icon: 'mdi:account-supervisor', roles: TEAM_VIEW_ROLES, children: [
    { id: 'view-zonal-managers', title: 'View Zonal Managers', path: '/team/zonal-managers', roles: ADMIN_ROLES },
    { id: 'view-area-managers',  title: 'View Area Managers',  path: '/team/area-managers',  roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER] },
    { id: 'view-executives',     title: 'View Executives',     path: '/team/executives',     roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER] },
    { id: 'view-sales-officer',  title: 'View Sales Officer',  path: '/team/sales-officers', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE] },
    { id: 'view-field-agent',    title: 'View Field Agent',    path: '/team/field-agents',   roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER] },
  ]},

    // ── Reports ───────────────────────────────────────────────────────────────
  // { id: 'reports', title: 'Reports', icon: 'mdi:chart-bar', roles: [...TEAM_TOUR_ROLES, ROLES.ACCOUNTS], children: [
  //   { id: 'todays-tours',  title: 'Todays Tours', path: '/reports/todays-tours', roles: ADMIN_ROLES },
  //   { id: 'joint-tours',   title: 'Joint Tours',  path: '/reports/joint-tours',  roles: TEAM_TOUR_ROLES },
  //   { id: 'advance-tours', title: 'Advance Tours', path: '/reports/advance-tours', roles: TEAM_TOUR_ROLES },
  //   { id: 'orders-report', title: 'Orders',        path: '/reports/orders',        roles: ADMIN_ROLES },
  //   { id: 'sales-report',  title: 'Sales',         path: '/reports/sales',         roles: ADMIN_ROLES },
  //   // { id: 'Field-report',  title: 'Field Reports',         path: '/reports/field-visits', roles: [ROLES.ACCOUNTS, ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN] },
    
  // ]},

  { id: 'accounts-section', title: 'Accounts', icon: 'mdi:cash-check',
  roles: [ROLES.ACCOUNTS],
  children: [
    { id: 'accounts-payments', title: 'Payments', path: '/orders/payments', roles: [ROLES.ACCOUNTS] },
  ]
},

  // ── Communication ─────────────────────────────────────────────────────────
  { id: 'communication', title: 'Communication', icon: 'mdi:message-text', roles: ALL_ROLES, children: [
    { id: 'chat',          title: 'Chat',          path: '/communication/chat',          roles: ALL_ROLES }
  ]},

  // ── Profile ───────────────────────────────────────────────────────────────
  { id: 'profile', title: 'Profile', icon: 'mdi:account-circle', roles: ALL_ROLES, children: [
    { id: 'view-profile', title: 'View Profile', path: '/view-profile', roles: ALL_ROLES },
  ]},

  {
  id: 'view-godown-employee',
  title: 'View Godown Employee',
  path: '/team/godown-employees',
  roles: [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN]
},
];

export default SIDEBAR_MENU;